export enum ActionType {
  edit,
  view,
  delete,
  move,
  assign,
  publish,
  services,
  activate,
};
